import { get } from 'app/utils/axios/kheti'
import { API } from '../models/api'
import { Product } from '../models/product'

//crop_ids and brand_ids can be comma seperated list or single cropId/brandId also
export interface RequestParmas {
  crop_id: string
  category_id: string
  search: string
  page: number
}

const fetchAllProducts = async (params: Partial<RequestParmas>) => {
  try {
    return await get<API<Product>>(`/farmer-360/v1/products`, {
      ...params,
      limit: 10,
    })
  } catch {
    return null
  }
}

export default fetchAllProducts
